const COLORS = {
  paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  shipped: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  delivered: "bg-white/10 text-white border-white/20",
  pending: "bg-[#FF9500]/15 text-[#FF9500] border-[#FF9500]/30",
  cancelled: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/30",
};

export const StatusBadge = ({ status, ...rest }) => (
  <span {...rest} className={`inline-block px-2 py-1 border font-mono text-[10px] uppercase tracking-widest ${COLORS[status] || COLORS.pending}`}>{status}</span>
);
